export default __webpack_public_path__ + "static/cashflow_202_1996_3-eeb373c73f7e6afc5ff56524d8bb58dc.jpeg";